import { createReducer, on } from '@ngrx/store';
import * as fromAccountActions from '../actions/account.action';
export const featureKey = 'account';

export interface State {
    userProfile: any;
    applicantDetails: any;
}

export const initialState: State = {
    userProfile: null,
    applicantDetails: null,
}

export const reducer = createReducer(
    initialState,
    on(fromAccountActions.getUserProfileSuccess, (state: State, props: any) => ({
        ...state,
        userProfile: props.data
    })),
    on(fromAccountActions.getApplicantDetailsSuccess, (state: State, props: any) => ({
        ...state,
        applicantDetails: props.data
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);